<template>
  <div>
    <el-form
      :model="notifyForm"
      :rules="rules"
      ref="notifyForm"
      style="margin-right: 30px"
    >
      <el-form-item label="SN号" :label-width="formLabelWidth" prop="snList">
        <el-checkbox
          :indeterminate="isSNIndeterminate"
          v-model="checkAllSN"
          @change="handleCheckAllSNChange"
          >全选</el-checkbox
        >
        <el-checkbox-group v-model="checkedSNList" @change="checkSNChange">
          <el-checkbox
            :key="item"
            v-for="item in allSNList"
            :label="item"
            :value="item"
          >
          </el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <el-form-item
        label="版本"
        :label-width="formLabelWidth"
        prop="versionList"
      >
        <el-checkbox
          :indeterminate="isVersionIndeterminate"
          v-model="checkAllVersion"
          @change="handleCheckAllVersionChange"
          >全选</el-checkbox
        >
        <el-checkbox-group
          v-model="checkedVersionList"
          @change="checkVersionChange"
        >
          <el-checkbox
            :key="item"
            v-for="item in allVersionList"
            :label="item"
            :value="item"
          >
          </el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <el-form-item :label-width="formLabelWidth" label="">
        <div style="margin-right: 30px">
          <el-button @click="closeDialog">取 消</el-button>
          <el-button
            type="primary"
            @click="confirmAction('notifyForm')"
            :disabled="disableSubmit"
            >确 定</el-button
          >
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
//上传OTA文件界面
import { handleResponse } from "../../utils/response";
import { API_URL, requestHeaders } from "../../api/request";
import { sendNotify, getVersion, getSN } from "@/api/otaApi";
import { getProjectList } from "../../api/projectApi";

export default {
  name: "ConfigNotifyForm",

  props: {
    otaId: {
      type: Number,
      default: "",
    },
    version: {
      type: Number,
      default: "",
    },
    dialogVisible: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    dialogVisible(newValue, oldValue) {
      if (newValue) {
        console.log("011001010110100101010110");
        getProjectList(1, 100);
      }
    },
    otaId(newValue, oldValue) {
      console.log("projectIdprojectIdprojectIdprojectIdprojectId");
      console.log(newValue);
      // alert(newValue)
      if (newValue) {
        this.clearData();
        console.log(typeof newValuex);
        this.notifyForm.otaId = newValue;
      }
    },
    version(newValue, oldValue) {
      console.log("011001010101010101");
      if (newValue) {
        this.version = newValue;
        this.getVersionList();
      }
    },
  },
  created() {
    console.log("CreateCreateCreateCreateCreateCreate");
  },
  mounted() {
    this.notifyForm.otaId = this.otaId;

    this.getVersionList();
    this.getSNList();

    console.log("888888888888");
  },
  methods: {
    getSNList() {
      getSN().then((response) => {
        handleResponse(
          response,
          (data) => {
            console.log("get sn list" + response);
            this.allSNList = data.list;
          },
          (error) => {
            console.log("get sn list" + error);
          }
        );
      });
    },

    getVersionList() {
      getVersion(this.version).then((res) => {
        handleResponse(
          res,
          (data) => {
            console.log("get version list" + data);
            this.allVersionList = data.list;
          },
          (error) => {
            console.log("get version list" + error);
          }
        );
      });
    },

    clearData() {
      this.notifyForm.otaId = -1;
      this.checkedVersionList = [];
      this.checkedSNList = [];
    },

    closeDialog() {
      this.$emit("clickCancel");
      console.log("ppppppppp");
    },
    confirmAction(formName) {
      console.log("checkedSNList" + this.checkedSNList.length);
      console.log("checkedVersionList" + this.checkedVersionList.length);

      if (this.checkedSNList.length == 0) {
        this.$message({
          type: "error",
          message: "请选择SN号!",
        });
        return;
      }
      if (this.checkedVersionList.length == 0) {
        this.$message({
          type: "error",
          message: "请选择版本号!",
        });
        return;
      }

      if (this.checkedVersionList.length > 0 && this.checkedSNList.length > 0) {
        console.log(
          "not empty not empty not empty not empty not empty not empty not empty not empty"
        );
        // alert('not empty')

        sendNotify(
          this.otaId,
          this.checkedSNList,
          this.checkedVersionList
        ).then((res) => {
          console.log("00010000000");
          handleResponse(
            res,
            (data) => {
              console.log("1111111");
              this.closeDialog();
              console.log(data);

              this.$message({
                type: "success",
                message: "通知发送成功!",
              });
            },
            (error) => {
              console.log("222222222");
              // console.log(error)
              // alert(error)
            }
          );
        });
      } else {
        console.log("empty");
        console.log(this.checkedVersionList.join(","));
        console.log(this.checkedSNList.join(","));
      }
    },

    handleCheckAllSNChange(val) {
      console.log("all sn val === %@", val);

      this.checkedSNList = val ? this.allSNList : [];
      this.isSNIndeterminate = false;
    },

    handleCheckAllVersionChange(val) {
      this.checkedVersionList = val ? this.allVersionList : [];
      this.isVersionIndeterminate = false;
    },
    checkSNChange(value) {
      this.checkedSNList = value;
      this.checkAllSN = value.length == this.allSNList.length;
      this.isSNIndeterminate =
        value.length == this.allSNList.length ? false : true;
    },

    checkVersionChange(value) {
      this.checkedVersionList = value;
      this.checkAllVersion = value.length == this.allVersionList.length;
      this.isVersionIndeterminate =
        value.length == this.allVersionList.length ? false : true;
    },
  },

  data() {
    return {
      checkAllSN: false,
      checkAllVersion: false,

      isSNIndeterminate: true,
      isVersionIndeterminate: true,

      disableSubmit: false,

      checkedSNList: [], //选中的sn
      checkedVersionList: [], //选中version

      allSNList: [],
      allVersionList: [],

      notifyForm: {
        otaId: -1,
      },

      rules: {
        snList: [
          {
            required: true,
            message: "请指定sn号",
            trigger: "blur",
          },
          {},
        ],
        versionList: [
          {
            required: true,
            message: "请指定版本号",
            trigger: "blur",
          },
        ],
      },
      formLabelWidth: "100px",
    };
  },
};
</script>

<style scoped></style>
